document
    .addEventListener("DOMContentLoaded", function () {

        const canvas = document.getElementById("hero-lightpass");
        if (canvas) {
            console.log("scroll video script loaded")

            let qflag = false;
            // Detect device type
            const isMobile = /Mobi|Android/i.test(navigator.userAgent);

            const context = canvas.getContext("2d");

            // URL
            const stripVersioning = url => url.split('?')[0];
            const getVersionValue = url => url.split('?')[1];
            // Cleaned base path
            const cleanAssetBasePath = stripVersioning(assetBasePath);
            const version_number = getVersionValue(assetBasePath);
            let rocket_base_path = "https://89005a70.delivery.rocketcdn.me/cdn/shop/t/7/assets/lowqcontroller_";
            let rocket_base_path1 = "https://89005a70.delivery.rocketcdn.me/cdn/shop/t/7/assets/hzmcontroller_";

            //let shopifycdn = "https://www.soildrops.com/cdn/shop/t/7/assets/lowqcontroller_";
            //let shopifycdn1 = "https://www.soildrops.com/cdn/shop/t/7/assets/hzmcontroller_";
            
            //Old WORKING CDN
            let shopifycdn = "https://d2z3gxouiwc498.cloudfront.net/lowqcontroller_";
            let shopifycdn1 = "https://d2z3gxouiwc498.cloudfront.net/hzmcontroller_";

            //let shopifycdn = "https://d2z3gxouiwc498.cloudfront.net/optimized/灰色";
            //let shopifycdn1 = "https://d2z3gxouiwc498.cloudfront.net/optimized/灰色";
            // Construct dynamic URLs - Working code old
            const currentFrame = index => `${shopifycdn}${ (index + 1)
                .toString()
                .padStart(5, '0')}.webp`;

            const currentFrame_high = index => `${shopifycdn1}${ (index + 1)
                .toString()
                .padStart(5, '0')}.webp`; 


            /*const currentFrame = index => `${shopifycdn}${ (index + 1)
                .toString()
                .padStart(4, '0')}-min.png`;

            const currentFrame_high = index => `${shopifycdn1}${ (index + 1)
                .toString()
                .padStart(4, '0')}-min.png`; */

            canvas.width = 1920;
            canvas.height = 1080;

            let controller_images = []
            let controller_images_high = []
            let temp_images = []
            let temp_images1 = []

            const frameCount = 390;

            const airpods = {
                frame: 0
            };

            async function loadImages() {
                
                const totalImages = 390;
                const firstBatchSize = Math.floor(totalImages / 2);
                const secondBatchSize = totalImages - firstBatchSize;
                // First batch: Load every other image (0, 2, 4, ..., 388)
                const firstBatchPromises = [];
                const firstBatchPromises1 = [];
                for (let i = 0; i < firstBatchSize; i++) {
                    const img = new Image();
                    img.src = currentFrame(i * 2); // Skipping every other image: 0, 2, 4, 6, ...
                    firstBatchPromises.push(new Promise((resolve) => {
                        //img.onload = () => resolve(img);
                        img.onload = () => {
                            //images[i * 2] = img; // Store in the array at correct index
                            temp_images[i * 2] = img;
                            //controller_images[i * 2] = img; if(i*2===0) render();
                            resolve(img); // Resolve when image is loaded
                        };
                    }));

                }

                // Wait for all images in the first batch to load
                await Promise.all(firstBatchPromises);
                controller_images = [...temp_images]
                console.log('low quality First batch loaded');
                render();
                console.log("render first frame")

                for (let i = 0; i < firstBatchSize; i++) {
                    const img = new Image();
                    img.src = currentFrame_high(i * 2); // Skipping every other image: 0, 2, 4, 6, ...
                    firstBatchPromises1.push(new Promise((resolve) => {
                        img.onload = () => {
                            //images[i * 2] = img; // Store in the array at correct index
                            temp_images1[i * 2] = img;
                            //controller_images[i * 2] = img;
                            resolve(img); // Resolve when image is loaded
                        };
                    }));

                }

                // Wait for all images in the first batch to load
                await Promise.all(firstBatchPromises1);
                controller_images_high = [...temp_images1]
                qflag = true
                console.log('high quality First batch loaded');
                render();

                // Second batch: Load the remaining images (1, 3, 5, ..., 389)
                const secondBatchPromises = [];
                for (let i = 0; i < secondBatchSize; i++) {
                    const img = new Image();
                    img.src = currentFrame_high(i * 2 + 1); // Skipping the first batch images: 1, 3, 5, 7, ...
                    secondBatchPromises.push(new Promise((resolve) => {
                        img.onload = () => {
                            controller_images_high[i * 2 + 1] = img; // Store in the array at correct index
                            resolve(img); // Resolve when image is loaded
                        };
                    }));

                }

                // Wait for all images in the second batch to load
                await Promise.all(secondBatchPromises);
                console.log('Second batch loaded');

                // console.log('All images loaded');
            }

            // Function to render the current frame (only when it's loaded)
            function render() {
                const currentImage = qflag
                    ? controller_images_high[airpods.frame]
                    : controller_images[airpods.frame];
                     console.log('currentImage' + currentImage);
        
                if (currentImage !== null && currentImage && currentImage.complete) {
                    context.clearRect(0, 0, canvas.width, canvas.height);
                    context.drawImage(currentImage, 0, 0);
                } else {
                    // Optionally, log or show a placeholder if the image isn't loaded yet
                    console.log('Image not yet loaded');
                }
            }

            loadImages();

            let mm = gsap.matchMedia();

            mm.add("(min-width: 701px)", () => {
               
                const timeline_intro = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".bg-waves",
                        start: "top top",
                        end: "+=400",
                        scrub: 1,
                        //markers:true
                    }
                });
                timeline_intro.fromTo(".intro-heading-div", {
                    top: "5%"
                }, {
                    top: "-100%"
                }, "<").to(".bg-waves", {
                    top: "-100%"
                }, "<2%");

                const timeline0 = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".animation",
                        start: "top top",
                        end: "+=4400",
                        scrub: 1,
                        //markers: true
                    }
                })
                timeline0.to(airpods, {
                    frame: frameCount - 1,
                    snap: "frame",
                    ease: "none",
                    onUpdate: render
                });

                const master = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".lottie-container",
                        start: "top top",
                        end: "+=8000",
                        pin: true,
                        aniticipatePin: 1,
                        scrub: 1,
                        //markers: true
                    }
                });

                master.fromTo("#p-1", {
                    y: 10,
                    opacity: 0
                }, {
                        y: 0,
                        opacity: 1
                    })
                    .to("#p-1", {opacity: 0})
                    .fromTo("#p-0", {
                        // left: "50%",
                        left: "50%",
                        opacity: 0
                    }, {
                        // left: "70%",
                        left: "75%",
                        opacity: 1
                    }, "<50%")
                    .to("#p-0", {opacity: 0})
                    .fromTo("#p-2", {
                        opacity: 0
                    }, {opacity: 1})
                    .fromTo("#p-3", {
                        opacity: 0
                    }, {opacity: 1})
                    .to("#p-2", {
                        opacity: 0
                    }, "<")
                    .to("#p-3", {opacity: 0})
                    .fromTo("#p-6", {
                        opacity: 0
                    }, {opacity: 1})
                   .to("#sensor", {
                        x: "-5vw",
                        opacity: 1
                    }, "<") 
                    .to([
                        "#sensor", "#p-6", ".animation"
                    ], {opacity: 0})
                    .fromTo("#mobile", {
                        y: "100%"
                    }, {y: "10%"})
                    .fromTo("#p-4", {
                        y: 10,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    }, "<")
                    .to("#p-4", {
                        y: -20,
                        opacity: 0
                    })
                    .fromTo("#p-5", {
                        y: 10,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    })
                    .fromTo(".pop-up", {
                        scale: 0,
                        opacity: 0
                    }, {
                        scale: 1,
                        opacity: 1,
                        // ease: "bounce.out"
                    })
                    .to("#notification", {
                        scale: 1.8,
                        rotation: 10
                    }, "<");

                const tl = gsap.timeline({repeat: -1, yoyo: true});

                tl.fromTo("#dots4", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }).fromTo("#dots5", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "+=0.1").fromTo("#dots3", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "<").fromTo("#dots6", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "+=0.1").fromTo("#dots2", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "<").fromTo("#dots7", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "+=0.1").fromTo("#dots1", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "<");
            })
            mm.add("(max-width: 700px)", () => {
                
                const timeline_intro = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".bg-waves",
                        start: "top top",
                        end: "+=400",
                        scrub: 1,
                        //markers:true
                    }
                });
                timeline_intro.fromTo(".intro-heading-div", {
                    top: "5%"
                }, {
                    top: "-100%"
                }, "<").to(".bg-waves", {
                    top: "-100%"
                }, "<2%");

                const timeline0 = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".animation",
                        start: "top top",
                        end: "+=4400",
                        scrub: 1,
                        //markers: true
                    }
                })
                timeline0.to(airpods, {
                    frame: frameCount - 1,
                    snap: "frame",
                    ease: "none",
                    onUpdate: render
                });

                const master = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".lottie-container",
                        start: "top top",
                        end: "+=8000",
                        pin: true,
                        aniticipatePin: 1,
                        scrub: 1,
                        //markers: true
                    }
                });

                master.fromTo("#p-1", {
                    y: 10,
                    opacity: 0
                }, {
                        y: 0,
                        opacity: 1
                    })
                    .to("#p-1", {opacity: 0})
                    .fromTo("#p-0", {
                        // left: "50%",
                        left: "50%",
                        opacity: 0
                    }, {
                        // left: "70%",
                        left: "75%",
                        opacity: 1
                    }, "<50%")
                    .to("#p-0", {opacity: 0})
                    .fromTo("#p-2", {
                        opacity: 0
                    }, {opacity: 1})
                    .fromTo("#p-3", {
                        opacity: 0
                    }, {opacity: 1})
                    .to("#p-2", {
                        opacity: 0
                    }, "<")
                    .to("#p-3", {opacity: 0})
                    .fromTo("#p-6", {
                        opacity: 0
                    }, {opacity: 1})
                    .to("#sensor", {
                        x: "-2vw",
                        opacity: 1
                    }, "<").fromTo(".animation",{x:0},{
                        x:-80
                    },"<") 
                    .to([
                        "#sensor", "#p-6", ".animation"
                    ], {opacity: 0})
                    .fromTo("#mobile", {
                        y: "100%"
                    }, {y: "12%"})
                    .fromTo("#p-4", {
                        y: 10,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    }, "<")
                    .to("#p-4", {
                        y: -20,
                        opacity: 0
                    })
                    .fromTo("#p-5", {
                        y: 10,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1
                    })
                    .fromTo(".pop-up", {
                        scale: 0,
                        opacity: 0
                    }, {
                        scale: 1,
                        opacity: 1,
                        // ease: "bounce.out"
                    })
                    .to("#mobile", {
                        y: "22%"
                    }, "<")
                    .to("#notification", {
                        scale: 1.8,
                        rotation: 10
                    }, "<");

                const tl = gsap.timeline({repeat: -1, yoyo: true});

                tl.fromTo("#dots4", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }).fromTo("#dots5", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "+=0.1").fromTo("#dots3", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "<").fromTo("#dots6", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "+=0.1").fromTo("#dots2", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "<").fromTo("#dots7", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "+=0.1").fromTo("#dots1", {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5
                }, "<");
            })
            console.log("code exec")

        }
    });